import { forwardRef } from "react";
import style from "./ChipGroup.module.scss";

const toArray = (val) => (val == null ? [] : Array.isArray(val) ? val : [val]);

export const ChipGroup = forwardRef(
  ({ name, options, multiple = false, selected, onToggle, value, onChange, onBlur, disabled = false, allowDeselect = false, errors }, ref) => {
    const current = toArray(selected !== undefined ? selected : value);

    const handleClick = (key) => {
      const isSelected = current.includes(key);

      let nextArray;

      if (multiple) {
        nextArray = isSelected ? current.filter((k) => k !== key) : [...current, key];
      } else {
        nextArray = isSelected && !allowDeselect ? current : [key];
      }

      const nextValue = multiple ? nextArray : nextArray[0] ?? null;

      onToggle?.(key, nextValue);
      onChange?.(nextValue);
      onBlur?.();
    };

    return (
      <>
        <div className={style.chips} role="group" aria-label={name} ref={ref}>
          {options.map((o) => (
            <button
              key={o.key}
              type="button"
              data-testid={`${name}-${o.key}`}
              className={style.chip}
              aria-pressed={current.includes(o.key)}
              disabled={disabled}
              onClick={() => handleClick(o.key)}
            >
              {o.value}
            </button>
          ))}
        </div>
        {errors && errors[name] && <span className={style.form_error_message}>{errors[name].message}</span>}
      </>
    );
  }
);

ChipGroup.displayName = "ChipGroup";
